import { AbstractRoomCommand } from "./AbstractRoomCommand";
export class EditRoutes extends AbstractRoomCommand {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mUndoData = new Map();
        this.mRedoData = new Map();
        for (let tRoute of this.mRoomManager.routes)
            this.mUndoData.set(tRoute, tRoute._saveUndoData());
    }
    isUndoable() {
        return (true);
    }
    execute(pParameter) {
        for (let tRoute of this.mRoomManager.routes)
            this.mRedoData.set(tRoute, tRoute._saveUndoData());
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve(true));
    }
    cancel() {
        this.undo();
    }
    undo() {
        this.mRoomManager.beginCollectRouteUpdates();
        this.mUndoData.forEach((pData, pRoute) => {
            if (pData != null && pRoute != null)
                pRoute._loadUndoData(pData);
        });
        this.mRoomManager.endCollectRouteUpdates();
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve());
    }
    redo() {
        this.mRoomManager.beginCollectRouteUpdates();
        this.mRedoData.forEach((pData, pRoute) => {
            if (pData != null && pRoute != null)
                pRoute._loadUndoData(pData);
        });
        this.mRoomManager.endCollectRouteUpdates();
        this.mApp.viewer.requestRenderFrame();
        return (Promise.resolve());
    }
}
